import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import AlertIcon from './AlertIcon';
import { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import ButtonTitle from './ButtonTitle';
import wrapperRouter from './wrapperRouter';
import { getRedirectUrl } from '../../shared/utilities/getRedirectUrl';
import { generateString } from '../../shared/utilities/generateString';
import { useNavigate } from 'react-router-dom';
import getCookie from '../../shared/utilities/getCookie';
import BusinessRedirectUser from '../BusinessRedirectUser';
import { RedirectReason } from '../../proto/out/ir/uid/services/session_api';
import { useDispatch, useSelector } from 'react-redux';
import { nextStepPage, nextStepTokenResponse } from '../../config/Enum/NextStep';
import { StepPages } from '../../proto/out/ir/uid/base/base';
import {
  CENTRAL_BANK_REDIRECT_URL,
  CENTRAL_BANK_REFERRAL_NAME,
  DIVAR_REDIRECT_URL,
  DIVAR_REFERRAL_NAME,
  EITTA_REDIRECT_URL,
  EITTA_REFERRAL_NAME,
  SNAP_SHOP_REFERRAL_NAME,
  SNAP_SHOP_PRODUCTION_REFERRAL_NAME,
  UID_REDIRECT_URL,
  UID_REFERRAL_NAME,
  FATA_REDIRECT_URL,
  FATA_REFERRAL_NAME,
  BALE_REFERRAL_NAME,
  SOROUSH_REFERRAL_NAME,
  SOROUSH_PLUS_PRODUCTION_REFERRAL_NAME,
  BALE_REDIRECT_URL, CRIMINAL_RECORD_REFERRAL_NAME,
} from '../../shared/constants/other';
import { setCookie } from '../../shared/utilities/setCookie';
import { SET_ALERT_MULTIPLE } from '../../redux/handleAlertModal/AlertModal';
import { navigateAway, reloadPage } from '../../shared/utilities/backNavigationGuard';

interface ProcessingModalPropsType {
  openModal: boolean;
  modalType: string;
  title: string;
  description: string;
  buttonUrl: string;
  navigate: (buttonUrl: string) => void;
}

const AlertModal = ({ openModal, modalType, title, description, buttonUrl, navigate }: ProcessingModalPropsType) => {
  const dispatch = useDispatch();
  const navigateUrl = useNavigate();
  const responseContext: any = useSelector<any>((state) => state.responseContextReducer.responseContext);

  const [isOpen, setIsOpen] = useState(false);
  const getUrl = localStorage.getItem('url');
  useEffect(() => {
    setIsOpen(openModal);
  }, [openModal]);
  const handleRedirectUrl = (buttonUrl: string) => {
    setCookie({ cookieName: 'referralName', cookieValue: '' });
    navigateAway(buttonUrl);
  };

  const handleClick = () => {
    setIsOpen(false);
    if (buttonUrl === 'businessReturnUrl') {
      BusinessRedirectUser(
        responseContext?.responseContext.nextStep[nextStepTokenResponse.REDIRECT_BUSINESS].navigationURI,
        responseContext?.responseContext.nextStep[nextStepTokenResponse.REDIRECT_BUSINESS].nextStepToken,
        RedirectReason?.REDIRECT_REASON_FINISHED_PROCESS,
        dispatch,
      );
    } else if (buttonUrl === 'cancelledFlow') {
      BusinessRedirectUser(
        responseContext?.responseContext.nextStep[nextStepTokenResponse.REDIRECT_BUSINESS].navigationURI,
        responseContext?.responseContext.nextStep[nextStepTokenResponse.REDIRECT_BUSINESS].nextStepToken,
        RedirectReason?.REDIRECT_REASON_USER_CANCELLED_PROCESS,
        dispatch,
      );
    } else if (buttonUrl === 'cancelPayment') {
      BusinessRedirectUser(
        responseContext?.responseContext.nextStep[nextStepTokenResponse.REDIRECT_BUSINESS].navigationURI,
        responseContext?.responseContext.nextStep[nextStepTokenResponse.REDIRECT_BUSINESS].nextStepToken,
        RedirectReason?.REDIRECT_REASON_USER_CANCELLED_PAYMENT,
        dispatch,
      );
    } else if (buttonUrl === 'refreshPage') {
      reloadPage();
    } else if (buttonUrl === 'retryUpload') {
      dispatch({
        type: SET_ALERT_MULTIPLE,
        payload: {
          alertModal: false,
          modalType: '',
          modalTitle: '',
          modalDescription: '',
          modalButtonUrl: '',
        },
      });
      window.dispatchEvent(new CustomEvent('retryUpload'));
    } else if (buttonUrl === 'editPersonalInformation' || buttonUrl === 'dismissAlert') {
      dispatch({
        type: SET_ALERT_MULTIPLE,
        payload: {
          alertModal: false,
          modalType: '',
          modalTitle: '',
          modalDescription: '',
          modalButtonUrl: '',
        },
      });
      if (buttonUrl === 'dismissAlert') {
        window.dispatchEvent(new CustomEvent('clearOtp'));
      }
    } else if (buttonUrl === DIVAR_REFERRAL_NAME) {
      navigateAway(localStorage.getItem('user_redirect_url') as string);
    } else if (buttonUrl === CRIMINAL_RECORD_REFERRAL_NAME) {
      navigateAway(localStorage.getItem('user_redirect_url') as string);
    } else if (buttonUrl === EITTA_REFERRAL_NAME) {
      navigateAway(localStorage.getItem('user_redirect_url') as string);
    } else if (buttonUrl === SNAP_SHOP_REFERRAL_NAME) {
      navigateAway(localStorage.getItem('user_redirect_url') as string);
    } else if (buttonUrl === SNAP_SHOP_PRODUCTION_REFERRAL_NAME) {
      navigateAway(localStorage.getItem('user_redirect_url') as string);
    } else if (buttonUrl === FATA_REFERRAL_NAME) {
      navigateAway(localStorage.getItem('user_redirect_url') as string);
    } else if (buttonUrl === BALE_REFERRAL_NAME) {
      navigateAway(localStorage.getItem('user_redirect_url') as string);
    } else if (buttonUrl === SOROUSH_REFERRAL_NAME) {
      navigateAway(localStorage.getItem('user_redirect_url') as string);
    } else if (buttonUrl === SOROUSH_PLUS_PRODUCTION_REFERRAL_NAME) {
      navigateAway(localStorage.getItem('user_redirect_url') as string);
    } else if (buttonUrl === CENTRAL_BANK_REFERRAL_NAME) {
      navigateAway(localStorage.getItem('user_redirect_url') as string);
    } else if (buttonUrl === UID_REFERRAL_NAME) {
      navigateAway(UID_REDIRECT_URL);
    } else if (buttonUrl === 'redirectDivar') {
      getRedirectUrl({
        state: generateString(8),
        redirectUrl: process.env.REACT_APP_REDIRECT_DIVAR_URL,
      });
    } else if (buttonUrl === 'failedPayment') {
      navigate(
        '/' +
          // @ts-ignore
          nextStepPage[StepPages[getCookie('nextStepPage')]],
      );
    } else if (buttonUrl === 'threeTimeAttempt') {
      BusinessRedirectUser(
        responseContext.responseContext.nextStep[nextStepTokenResponse.GENERAL].navigationURI,
        responseContext.responseContext.nextStep[nextStepTokenResponse.GENERAL].nextStepToken,
        RedirectReason.REDIRECT_REASON_USER_CANCELLED_PROCESS,
        dispatch,
      );
    } else if (buttonUrl === 'NAJI') {
      // @ts-ignore
      navigateAway(getUrl);
    } else {
      handleRedirectUrl(buttonUrl);
    }
  };

  return (
    <div>
      <Dialog
        open={isOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{ sx: { width: '400px', maxWidth: '70%', height: 'auto' } }}
      >
        <DialogContent style={{ textAlign: 'center', overflow: 'hidden' }}>
          <DialogContentText style={{ margin: '0 auto', display: 'table' }} id="alert-dialog-description">
            <p style={{ fontFamily: 'Medium', color: 'rgb(36 36 75 / 98%)', fontSize: '15px', fontWeight: 'bold' }}>{title}</p>
          </DialogContentText>
          <br />
          <DialogContentText style={{ margin: '0 auto', display: 'table' }} id="alert-dialog-description">
            <AlertIcon value={modalType} />
          </DialogContentText>
          <DialogContentText mt={4} id="alert-dialog-description">
            <p style={{ fontFamily: 'Medium', color: 'rgb(36 36 75 / 98%)', fontSize: '16px'}}>{description}</p>
          </DialogContentText>
          <Button
            style={{
              height: '50px',
              // width: '86%',
              // backgroundColor: '#17b0a8',
              borderRadius: '35px',
              marginTop: '10px',
            }}
            onClick={handleClick}
            fullWidth={true}
            variant="contained"
          >
            <span style={{ fontSize: 17, fontFamily: 'Medium, sans-serif' }}>
              <ButtonTitle value={modalType} buttonUrl={buttonUrl} />
            </span>
          </Button>
        </DialogContent>
      </Dialog>
    </div>
  );
};
export default wrapperRouter(AlertModal);
